import styled from "styled-components"


const HeaderBody = styled.div`
    padding-top: 0.5em;
    width: 80%;
    text-align: left;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export default HeaderBody;